import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MailIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7L10.28 12.8C11.31 13.52 12.69 13.52 13.72 12.8L22 7"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 18L10 13"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 18L14 13"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

MailIcon.displayName = 'MailIcon';
